import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class Workflow {

    description = document.querySelector('.workflow__desc');
    list = document.querySelector('.workflow__list');
    tools = document.querySelectorAll('.workflow__list .tool');
    section = document.querySelector('.workflow');
    constructor() {
        this.animeWorkflow();
    }


    animeWorkflow = () => {
        gsap.from(this.tools, {
            opacity: 0,
            stagger: 0.1,
            scrollTrigger : {
                trigger: this.list,
                scrub: true,
                start: 'top 85%',
                end: 'bottom 65%',
            }
        })
    }
}